import styled from 'styled-components';

export const ConfirmationContainer = styled.div`
  padding: ${({ theme }) => theme.spacing[8]};
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 ${({ theme }) => theme.spacing[48]};
`;
